import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { ErrorBlock } from './ErrorBlock';
import File from './File';
export const MultiFileList = memo(function MultiFileList({ filesState, tryAnotherText, handleReset, errorBlockTitle }) {
    const errors = useMemo(() => filesState.reduce((acc, item) => (item.error ? [...acc, `${item.fileName} - ${item.error}`] : acc), []), [filesState]);
    if (errors.length) {
        return _jsx(ErrorBlock, { errors: errors, onResetClick: handleReset, errorBlockTitle: errorBlockTitle, tryAgainText: tryAnotherText });
    }
    return (_jsx(_Fragment, { children: filesState.map((file) => (_jsx(File, { fileName: file.fileName, progress: file.progress, tryAnotherText: tryAnotherText, isUploading: file.isUploading, error: file.error, success: file.success }, file.uniqueIdentifier))) }));
});
